import { defineMessages } from 'react-intl';

export default defineMessages({
    question: {
        id: 'exitPoll.question',
        defaultMessage: 'Can you tell us where you heard about iwoca?'
    },
    savedTitle: {
        id: 'exitPoll.savedTitle',
        defaultMessage: 'Thank you!'
    },
    savedSubText: {
        id: 'exitPoll.savedSubText',
        defaultMessage: 'We value your input'
    },
    letter: {
        id: 'exitPoll.answer.letter',
        defaultMessage: 'Letter'
    },
    search_engine: {
        id: 'exitPoll.answer.search_engine',
        defaultMessage: 'Search Engine'
    },
    radio: {
        id: 'exitPoll.answer.radio',
        defaultMessage: 'Radio'
    },
    train_or_bus_ad: {
        id: 'exitPoll.answer.train_or_bus_ad',
        defaultMessage: 'Bus, Tube or Rail advert'
    },
    other: {
        id: 'exitPoll.answer.other',
        defaultMessage: 'Other'
    },
    word_of_mouth: {
        id: 'exitPoll.answer.word_of_mouth',
        defaultMessage: 'Word of mouth'
    },
    in_the_news: {
        id: 'exitPoll.answer.in_the_news',
        defaultMessage: 'In the news'
    },
    social_media: {
        id: 'exitPoll.answer.social_media',
        defaultMessage: 'Social media'
    },
    // Deprecated 3 poll selections for UK only but DE is still available.
    friend_or_press: {
        id: 'exitPoll.answer.friend_or_press',
        defaultMessage: 'Friends or press'
    },
    advisor: {
        id: 'exitPoll.answer.advisor',
        defaultMessage: 'Advisor'
    },
    email: {
        id: 'exitPoll.answer.email',
        defaultMessage: 'Email'
    }
});
